import { render, staticRenderFns } from "./HJ01561.vue?vue&type=template&id=1bd96120&scoped=true&"
import script from "./HJ01561.vue?vue&type=script&lang=js&"
export * from "./HJ01561.vue?vue&type=script&lang=js&"
import style0 from "./HJ01561.vue?vue&type=style&index=0&id=1bd96120&prod&lang=less&scoped=true&"
import style1 from "./HJ01561.vue?vue&type=style&index=1&id=1bd96120&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd96120",
  null
  
)

export default component.exports